import { withStyles } from '@material-ui/core/styles'
import Tab from '@material-ui/core/Tab'
import classNames from 'classnames'

const styles = theme => ({
  active: {
    backgroundColor: theme.colors.white,
    borderTop: `2px solid ${theme.colors.navy}`,
  },
  inactive: {
    backgroundColor: 'transparent',
    borderTop: 'unset',
  },
})

function PrimaryTab(props) {
  const { value, label, onClick, classes, style, textTransformUnset, activeElement, ...rest } = props
  const localStyle = textTransformUnset && {
    textTransform: 'unset',
  }
  return (
    <Tab
      style={{ ...localStyle, ...style }}
      value={value}
      label={label}
      aria-label={label}
      onClick={onClick}
      className={classNames(classes.tab, activeElement ? classes.active : classes.inactive)}
      {...rest}
    />
  )
}

export default withStyles(styles)(PrimaryTab)
